import { Alert, Select, Skeleton } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import SwitchCourseBoard from "../../../../../components/montessori-course-board/SwitchCourseBoard";
import { serverUrl } from "../../../../../nestserver";

const { Option } = Select;

/**
 * Parents may have children in different classes, so the board is chosen by
 * child. A single child is selected automatically rather than making the parent
 * pick from a list of one.
 */
function ParentCourseBoard() {
  const [studentId, setStudentId] = useState(null);

  async function fetchChildren() {
    const res = await axios.get(`${serverUrl}/students/by-parent/`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data?.result ?? [];
  }

  const children = useQuery("students/by-parent", fetchChildren);

  useEffect(() => {
    if (!studentId && children.data?.length === 1) {
      setStudentId(children.data[0]._id);
    }
  }, [children.data, studentId]);

  const selectedChild = children.data?.find((c) => c._id === studentId);
  const classId = selectedChild?.class?._id || selectedChild?.class;

  return (
    <div>
      <div className="px-8 pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className="bg-white drop-shadow-md p-8 w-full"
        >
          <div className="text-2xl text-orange-500 font-semibold pb-4">
            Course Board
          </div>

          {children.isLoading ? (
            <Skeleton active paragraph={{ rows: 1 }} />
          ) : children.data?.length ? (
            <div className="flex gap-4 items-center" style={{ maxWidth: 420 }}>
              <h5 className="text-base font-semibold whitespace-nowrap">
                Child
              </h5>
              <Select
                showSearch
                showArrow
                placeholder="Select child"
                className="w-full"
                value={studentId ?? undefined}
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(value) => setStudentId(value)}
                optionFilterProp="children"
              >
                {children.data.map((child) => (
                  <Option key={child._id} value={child._id}>
                    {`${child?.first_name ?? ""} ${child?.last_name ?? ""}`.trim()}
                  </Option>
                ))}
              </Select>
            </div>
          ) : (
            <Alert
              type="info"
              showIcon
              message="No children linked"
              description="There are no students linked to this account yet."
            />
          )}
        </div>
      </div>

      {classId ? (
        <SwitchCourseBoard classId={classId} showBackButton={false} />
      ) : children.data?.length && !studentId ? (
        <div className="px-8 pt-6 text-gray-400">
          Select a child to see their class course board.
        </div>
      ) : null}
    </div>
  );
}

export default ParentCourseBoard;
